import { Component, Inject, ViewChild, forwardRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FilesListComponent } from '../files-list/files-list.component';
import { StorageUtilsService } from '../../services/storage-utils.service';

@Component({
  selector: 'folder-selector-modal',
  templateUrl: './folder-selector-modal.component.html',
  styleUrls: ['./folder-selector-modal.component.scss'],
  standalone: false,
})
export class FolderSelectorModalComponent {
  folderPath: string = '';
  isTrashFolder: boolean = false;
  excludedFiles: string[] = [];
  StorageUtilsService = StorageUtilsService;

  @ViewChild(forwardRef(() => FilesListComponent))
  filesList: FilesListComponent;

  constructor(
    public dialogRef: MatDialogRef<FolderSelectorModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FolderSelectorModalData,
  ) {
    this.folderPath = data.folderPath;
    this.isTrashFolder = data.isTrashFolder;
    this.excludedFiles = data.excludedFiles;
  }

  close(files: any[]) {
    this.dialogRef.close(files);
  }

  dismiss() {
    this.dialogRef.close(false);
  }
}

interface FolderSelectorModalData {
  folderPath: string;
  isTrashFolder: boolean;
  excludedFiles: string[];
}
